/* This is a manually compiled routes file that should exist as long as
   the automatically generated routes in Podio.DynamicRoutes are not flexible enough
 */
define('lib/Podio.DynamicContentRoutes',['require'],function (require) {

  return {
    '/{org_slug}/{space_slug}/apps/{app_id}/items/{app_item_id}:?query::#fragment:': {
      bundle: 'items/show_v2',
      section: 'items'
    },
    '/{org_slug}/{space_slug}/apps/{app_id}/edit:?query::#fragment:': {
      bundle: 'items/show_v2',
      section: 'items'
    },
    '/{org_slug}/{space_slug}/apps/new': {
      bundle: 'items/app_settings_modal',
      section: 'app_settings_modal'
    },
    '/{org_slug}/{space_slug}/apps/{app_id}/settings': {
      bundle: 'items/app_settings_modal',
      section: 'app_settings_modal'
    },
    '/{org_slug}/{space_slug}/apps/{app_id}/dashboard': {
      bundle: 'apps/dashboard',
      section: 'apps_dashboard'
    },
    '/{org_slug}/{space_slug}/apps/{app_id}/dashboard/widgets/{widget_id}': {
      bundle: 'apps/dashboard',
      section: 'apps_dashboard'
    }
  };

});
